"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.testsConfig = exports.AB_TESTS_CONFIG = void 0;
exports.AB_TESTS_CONFIG = {
    getstarted_cro_redesign_v2: {
        variants: {
            'control-getstarted-cro-redesign': {
                ab_test_variation: 'control-getstarted-cro-redesign'
            },
            'test-getstarted-cro-redesign': {
                ab_test_variation: 'test-getstarted-cro-redesign'
            }
        },
        controlVariantName: 'control-getstarted-cro-redesign',
        pages: ['/getstarted'],
        shouldAffectBuild: true
    },
    hp_photographers_entrypoints: {
        variants: {
            'control-hp-photographers-entrypoints': {
                ab_test_variation: 'control-hp-photographers-entrypoints'
            },
            'test-hp-photographers-entrypoints': {
                ab_test_variation: 'test-hp-photographers-entrypoints'
            }
        },
        controlVariantName: 'control-hp-photographers-entrypoints',
        pages: ['/'],
        shouldAffectBuild: false
    },
    marketing_site_onetap: {
        variants: {
            disabled: { ab_test_variation: 'disabled' },
            enabled: { ab_test_variation: 'enabled' }
        },
        controlVariantName: 'disabled',
        shouldAffectBuild: false
    }
};
exports.testsConfig = {
    ...exports.AB_TESTS_CONFIG
};
